import { render, staticRenderFns } from "./AlertDestinationListScreen.vue?vue&type=template&id=43c449d6&scoped=true&lang=pug"
import script from "./AlertDestinationListScreen.vue?vue&type=script&lang=ts"
export * from "./AlertDestinationListScreen.vue?vue&type=script&lang=ts"
import style0 from "./AlertDestinationListScreen.vue?vue&type=style&index=0&id=43c449d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c449d6",
  null
  
)

export default component.exports